import React, { Component } from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import SendThumbnail from 'components/mix/SendThumbnail.js';
import OutputChannelChooser from './OutputChannelChooser.js';
import { connect } from "react-redux";
import {setSelectedGroup} from 'actions/index.js';
import {setSelectedTrack} from 'actions/index.js';

class SendComponent extends Component {
    constructor(props) {
        super(props);
    }
  
    isSelected() {
        return this.props.send == this.props.selectedGroup;
    }

    onChangeVolume(volume) {
        this.props.send.setVolume(volume);
        this.props.setSelectedGroup(this.props.send);
        this.props.setSelectedTrack(undefined);
    }

    render() {
        return (
            <div
              className={this.isSelected() ? 'group selected' : 'group'}>
              <div className="volume-slider-container">
                <ReactBootstrapSlider
                  handle="square"
                  value={this.props.volume}
                  change={(e) => this.onChangeVolume(e.target.value)}
                  step={0.1}
                  max={3}
                  min={-40}
                  orientation="vertical"
                  reversed={true}
                  /> 
              </div>
                {!this.props.channelMixer.stereoConnected ? 
                  <OutputChannelChooser channel={this.props.send}/>
                  : ''}
              <SendThumbnail
                send={this.props.send}/>
              <div className="send-name">
                SEND {this.props.send.name}
              </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        selectedGroup: state.mix.selectedGroup,
        volume: props.send.getVolume(),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setSelectedGroup: group => dispatch(setSelectedGroup(group)),
        setSelectedTrack: track => dispatch(setSelectedTrack(track))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SendComponent);
